<template>
    <PortalAbonadosComponent :loading="loading" :abono="abono">
        <template v-slot:buscar-abonado>
            <BuscarAbonadoSGA :error="error_mensaje" :loading="loading" @buscarAbonado="buscarAbono" />
        </template>
        <template v-slot:content>
            <b-col cols="12" md="8" style="font-weight: bold; font-size: 18px; line-height: 1.8rem;">
                <b-row>
                    <b-col cols="12">
                        <span class="altcolor">Nº de abonado:</span> {{ abono.n_abonado }}
                    </b-col>
                    <b-col cols="12">
                        <span class="altcolor">Nombre:</span> {{ abono.name + ' ' + abono.lastName }}
                    </b-col>
                    <b-col cols="12">
                        <span class="altcolor">Género:</span> {{ abono.gender }}
                    </b-col>
                    <b-col cols="12">
                        <span class="altcolor">Email:</span> {{ abono.email }}
                    </b-col>
                    <b-col cols="12">
                        <span class="altcolor">Teléfono:</span> {{ abono.phone }}
                    </b-col>
                    <b-col cols="12">
                        <span class="altcolor">Dirección:</span> {{ getDireccion(abono.address) }}
                    </b-col>
                    <b-col cols="12">
                        <span class="altcolor">Fecha de alta:</span> {{ formatearFecha(abono.createdAt) }}
                    </b-col>
                    <b-col cols="12">
                        <span class="altcolor">Provincia:</span> {{ abono.address.city }}
                    </b-col>
                    <b-col cols="12">
                        <span class="altcolor">Localidad:</span> {{ abono.address.state }}
                    </b-col>
                    <b-col cols="12">
                        <span class="altcolor">Estado:</span> {{ abono.status === 'active' ? 'Activo' : 'Inactivo' }}
                    </b-col>
                    <b-col cols="12" class="mt-3" v-if="abono.status === 'active'">
                        <div class="mb-2 mb-md-0 d-flex flex-column flex-md-row">
                            <a class="button mb-2 mb-md-0 mr-md-2" target="_blank" :href="abono.sga_google_wallet_url">
                                <i class="fas fa-wallet mr-1" :disabled="loading"></i> Descargar Passwallet
                            </a>
    
                            <a class="button mb-2 mb-md-0 mr-md-2" target="_blank" :href="abono.sga_apple_wallet_url">
                                <i class="fas fa-ticket-alt mr-1" :disabled="loading"></i> Descargar Passbook
                            </a>
                        </div>
                    </b-col>
                </b-row>
            </b-col>
        </template>
    </PortalAbonadosComponent>
</template>

<script>
    import BuscarAbonadoSGA from './BuscarAbonadoSGA';
    import PortalAbonadosComponent from './PortalAbonadosComponent';

    export default {
        name: 'PortalAbonadosSga',
        data() {
            return {
                loading: false,
                error_mensaje: null,
                abono: null
            }
        },
        methods: {
            buscarAbono(abono) { 
                this.loading = true;

                const params = {
                    tid: this.configuracion.hash_teatro,
                    filters: {
                        pin: abono.pin,
                        beneficiary_id_doc: abono.beneficiary_id_doc,
                        subscriber_number: abono.subscriber_number,
                        tid: this.configuracion.hash_teatro
                    }
                }
          
                this.$store.dispatch(this.config.getVuexAlias('sga.buscar.abono'), params).then(res => {
                    this.abono = res.data.data;
                    this.abono.pin = data.pin;
                    this.abono.n_abonado = abono.subscriber_number;
                }).catch(error => {
                    this.error_mensaje = error.response.data.message;
                    this.$toast.error(this.mensaje);
                }).finally(() => {
                    this.loading = false;                 
                });
            },
            getDireccion(address) {
                if (!address) return '';

                const { streetLine1, zipCode, city, state, country } = address;

                return [
                    streetLine1,
                    `${zipCode} ${city}`,
                    state !== city ? state : null,
                    country
                ].filter(Boolean).join(', ');
            },
            formatearFecha(fecha) {
                if (!fecha) return '';

                const meses = [
                    'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
                    'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
                ];

                const date = new Date(fecha.replace(' ', 'T'));
                const dia = date.getDate();
                const mes = meses[date.getMonth()];
                const anio = date.getFullYear();
                const hora = date.toLocaleTimeString('es-ES', {
                    hour: '2-digit',
                    minute: '2-digit'
                });

                return `${dia} de ${mes} del ${anio} a las ${hora}`;
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            }
        },
        components: {
            BuscarAbonadoSGA, PortalAbonadosComponent
        }
    }
</script>